import client from '@libs/HttpClient';

class SkillScoringParameterService {
    // List Skill Scoring Parameters
    static async listSkillScoringParameters(request) {
    const page_no = request.queryKey[1];
    const searchText = request.queryKey[2];
    const status = request.queryKey[3];

    const res = await client.get(
        `/skill-scoring-parameters?search=${searchText || ''}&page=${page_no}&skill_status=${status || ''}`
    );

    return res.data?.data || res.data; 
    }

    // View a single Skill Scoring Parameter
    static viewSkillScoringParameter(id) {
        return client.get(`/skill-scoring-parameters/${id}`);
    }

    // Add new Skill Scoring Parameter
    static addSkillScoringParameter(request) {
        return client.post('/skill-scoring-parameters', request);
    }

    // Update existing Skill Scoring Parameter
    static updateSkillScoringParameter(request) {
        return client.put(`/skill-scoring-parameters/${request.id}`, request);
    }

    // Delete a Skill Scoring Parameter
    static deleteSkillScoringParameter(request) {
        return client.delete(`/skill-scoring-parameters/${request.id}`, request);
    }
    
    static statusChangeSkillScoringParameter(request) {
    return client.patch(
        `/skill-scoring-parameters/change-status/${request.id}`,
        { skill_status: request.skill_status } // only the DB column
    );
}
}

export { SkillScoringParameterService };